import { render, staticRenderFns } from "./PurchaseManagementListPage.vue?vue&type=template&id=2e179bac&scoped=true&"
import script from "./PurchaseManagementListPage.vue?vue&type=script&lang=ts&"
export * from "./PurchaseManagementListPage.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseManagementListPage.vue?vue&type=style&index=0&id=2e179bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e179bac",
  null
  
)

export default component.exports